/**
 * Service/Index Controller
 *
 * Displays information about a particular order
 */

// the constructor for this object
function ServiceIndexController() { }

// the object
ServiceIndexController.prototype = {
    constructor: ServiceIndexController,

    // the product code of the order
    productCd: false,

    // the base order id
    baseOrderId: false,

    // initialize the controller
    init: function()
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();

        // register the route variables used by this controller
        this._registerRouteVariables();

        PortalHelper.debugMessage('Service Index Initialized');
    },

    // run the controller
    run: function()
    {
        // get and populate the orders
        this._getOrder();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Service Index Controller Ran');
    },

    // get the route variables and include them in the controller
    _registerRouteVariables: function()
    {
        var segments = PortalMain.getRouteSegments();

        // set the product cd
        if (segments.length == 2) {
            this.productCd = segments[0];
            this.baseOrderId = segments[1];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },

    // register the javascript events
    _registerEvents:  function()
    {

    },

    // get the orders from the api
    _getOrder: function(overrideZero = false)
    {
        // hide the error messages
        this._hideOrderError();

        // make the request
        var orderRequest = new PortalRequest;
        orderRequest.makeRequest(
            '/orders/get-order',
            {
                baseOrderId: this.baseOrderId
            },
            function(data) {

                // show product specific elements
                PortalMain.ServiceIndexController.showProductElements(data);

                // set the headline
                PortalMain.ServiceIndexController.setHeadline(data);

                // set the breadcrumbs
                PortalMain.ServiceIndexController.setBreadcrumbs(data);

                // fill the control buttons
                PortalMain.ServiceIndexController.populateControls(data);

                // fill the order
                PortalMain.ServiceIndexController.populateOrderDetails(data);

                // fill the components
                PortalMain.ServiceIndexController.populateComponents(data, overrideZero);

                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#order-details', false);
                PortalHelper.loadingOverlay('#components-table', false);
            },
            function(data, code, message) {

                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#order-details', false);
                PortalHelper.loadingOverlay('#components-table', false);

                PortalMain.ServiceIndexController._showOrderError();
            }
        );
    },

    // show elements that are specific to a particular product
    showProductElements: function(data)
    {
        var productCd = data.product_cd;
        $('*[data-products-show*=' + productCd + ']').removeClass('hidden');

        $('*[data-products-hide]').not('[data-products-hide*=' + productCd + ']').removeClass('hidden');
    },

    // set the headline according to the current product
    setHeadline: function(data)
    {
        var headline = '';

        // find the product in question
        var products = PortalMain.PortalProducts.getProducts();
        for (var i in products) {
            var product = products[i];
            if (product.product_cd == data.product_cd.toUpperCase()) {
                headline = product.product;
            }
        }

        $('#headline').html(headline);
    },

    // set the breadcrumbs according to the current product, and order
    setBreadcrumbs: function(data)
    {
        //get the product group
        var group = PortalMain.PortalProducts.getProductGroupByProductCd(data.product_cd);

        var url = '/portal/services/' + group.path;
        $('.breadcrumbs .bc-service-group').attr('href', url);
        $('.breadcrumbs .bc-service-group').html(group.label);

        var orderLink = PortalMain.PortalProducts.getProductLink(data.product_cd, data.base_order_id);
        $('.breadcrumbs a.bc-order').attr('href', orderLink);
        $('.breadcrumbs .bc-order').html('#' + data.order_number);

        $('.breadcrumbs').removeClass('hidden');
    },

    // fill the controls with proper links
    populateControls: function(data)
    {
        // apply the change alias link
        var changeAliasLink = PortalConfig.portalUrl;
        changeAliasLink += '/service/change-alias';
        changeAliasLink += '/' + data.base_order_id;
        $('#change-order-alias-button').attr('href', changeAliasLink);

        // apply the trouble ticket link
        var createTicketLink = PortalConfig.portalUrl;
        createTicketLink += '/r/tickets/new-ticket';
        createTicketLink += '/' + data.base_order_id;
        $('#create-trouble-ticket-button').attr('href', createTicketLink);

        // turn on the submit button
        PortalHelper.enableButton('#change-order-alias-button');
        PortalHelper.enableButton('#create-trouble-ticket-button');

    },

    // populate the orders table
    // this can be used by an external product controller
    populateOrderDetails: function(order)
    {
        // set the order number
        $('#order-details .order-number .value').html(order.order_number);

        // set the order number link if needed
        if ($('#order-details .order-number .value').is('a')) {
            var orderLink = PortalMain.PortalProducts.getProductLink(order.product_cd, order.base_order_id);
            $('#order-details .order-number .value').attr('href', orderLink);
        }

        // set the product
        $('#order-details .product .value').html(order.product);

        // set the account number
        if (order.account.account_number == undefined) {
            $('#order-details .account-number').remove();
            $('#order-details .account-name').removeClass('half');
        } else {
            $('#order-details .account-number .value').html(order.account.account_number);
        }

        // set the account name
        if (order.account.name == undefined) {
            $('#order-details .account-name').remove();
            $('#order-details .account-number').removeClass('half');
        } else {
            $('#order-details .account-name .value').html(order.account.name);
        }


        // set the mrc charges
        if (order.mrc_charges == 0) {
            $('#order-details .mrc-charges').remove();
        } else {
            var mrcCharges = PortalHelper.numberToDollars(order.mrc_charges);
            $('#order-details .mrc-charges .value').html(mrcCharges);
        }

        // set the uss circuit id
        $('#order-details .uss-circuit-id .value').html(order.uss_circuit_id);

        // set the circuit id link if needed
        if ($('#order-details .uss-circuit-id .value').is('a')) {
            var orderLink = PortalMain.PortalProducts.getProductLink(order.product_cd, order.base_order_id);
            $('#order-details .uss-circuit-id .value').attr('href', orderLink);
        }

        // set the alias or remove if not available
        if (order.alias == null) {
            $('#order-details .alias').remove();
        } else {
            $('#order-details .alias .value').html(order.alias);
        }

        // set the customer reference or remove if not available
        if (order.customer_ref == null) {
            $('#order-details .customer-reference').remove();
        } else {
            $('#order-details .customer-reference .value').html(order.customer_ref);
        }

        // set the contract start date
        var contractStart = PortalHelper.formatDate(order.contract_start_date);
        $('#order-details .contract-start .value').html(contractStart);
        if (['NOCH','UK'].indexOf(order.term_cd) != -1) {
            $('#order-details .contract-start').removeClass('half');
        }

        // set the term or remove it if is a certain type
        if (['NOCH','UK'].indexOf(order.order_term_cd) != -1) {
            $('#order-details .term').remove();
        } else {
            $('#order-details .term .value').html(order.order_term);
        }

    },

    // hide the order error
    _hideOrderError: function(code, message)
    {
        $('#order-details').removeClass('box-error');
        $('#order-details').attr('data-error-message', '');
    },

    // there was an error loading the invoice data from the api, so show the error
    _showOrderError: function()
    {
        $('#order-details').addClass('box-error');
        $('#order-details').attr('data-error-message', 'No order found.');
    },

    // populate the order components
    // this can be used by an external product controller
    populateComponents: function(order, populateComponents = false)
    {
        var customerOrderComponents = order.all_customer_order_components;
        // clear the old components
        $('#components-table tbody tr:not(.clone-source)').remove();

        // show the components, and their mrc charges in the table
        for (var i in customerOrderComponents) {
            for (var i2 in customerOrderComponents[i].current_customer_services) {

                var component = customerOrderComponents[i].current_customer_services[i2];
                if ( component.mrc_charges != 0 || populateComponents == true ){
                    var newEntry = $('#components-table tbody .clone-source').clone();
                    newEntry.removeClass('clone-source');

                    // add the component name
                    $('.component', newEntry).html(component.service_component.description);

                    // add the mrc charges
                    var mrcCharges = PortalHelper.numberToDollars(component.mrc_charges);
                    $('.mrc-charges', newEntry).html(mrcCharges);

                    // add to to the table
                    $('#components-table tbody').append(newEntry);
                }
            }
        }

        // apply the total mrc charges
        var mrcCharges = PortalHelper.numberToDollars(order.mrc_charges);
        $('#total-mrc').html(mrcCharges);

    },

}